import { EBroadbandTechnology, ICatalogOffer } from "@features/cart/ICart";
import { EServiceGroup } from "@constants";

interface IUsageResponse {
    description: string;
    displayOrder: number;
}

export interface IOfferResponse {
    catalogOfferCode: string;
    description: string;
    comment: string;
    displayOrder: number;
    recurringChargeAmount: number;
    discountedRecurringChargeAmount: number;
    activationFee?: number;
    usages: IUsageResponse[];
    broadbandTechnology: string | null;
    serviceGroup: string;
}

export const getResponseToState = (response: IOfferResponse[]): ICatalogOffer[] =>
    response.map((offer) => ({
        catalogOfferCode: offer.catalogOfferCode,
        description: offer.description,
        comment: offer.comment,
        displayOrder: offer.displayOrder,
        recurringChargeAmount: offer.recurringChargeAmount,
        discountedRecurringChargeAmount: offer.discountedRecurringChargeAmount,
        activationFee: offer.activationFee,
        usages: offer.usages
            .map((usage) => ({
                description: usage.description,
                displayOrder: usage.displayOrder,
            }))
            .sort((prev, curr) => prev.displayOrder - curr.displayOrder),
        broadbandTechnology: (offer.broadbandTechnology as EBroadbandTechnology) ?? undefined,
        serviceGroup: offer.serviceGroup as EServiceGroup,
    }));
